import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';

import {
  TellentAdoptedStylesheetsDirective,
  TellentSubscriptionBannerComponent,
  TellentThemeDirective,
} from '@core/tellent-smart-ui';
import type { InputSignalLike, TellentWebComponent } from '@core/tellent-types';
import type { IconName } from '@core/user-interface-legacy';

@Component({
  selector: 'x-subscription-banner',
  template: `
    <tlc-subscription-banner
      [message]="message()"
      [type]="type()"
      [iconName]="iconName()"
      [ctaLabel]="ctaLabel()"
      [isDismissible]="isDismissible()"
      (ctaClick)="ctaClick.emit()"
      (dismiss)="dismiss.emit()"
    >
      <slot></slot>
    </tlc-subscription-banner>
  `,
  styleUrls: ['../../../styles.less'],
  styles: `
    :host {
      display: block;
    }
  `,
  hostDirectives: [TellentThemeDirective, TellentAdoptedStylesheetsDirective],
  imports: [TellentSubscriptionBannerComponent],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentSubscriptionBannerWrapComponent {
  public message: InputSignalLike<string> = input('');
  public type: InputSignalLike<'normal' | 'information' | 'warning' | 'danger'> = input<
    'normal' | 'information' | 'warning' | 'danger'
  >('information');
  public iconName: InputSignalLike<IconName> = input<IconName>('info-outline');
  public ctaLabel: InputSignalLike<string | null> = input<string | null>(null);
  public isDismissible: InputSignalLike<boolean> = input(false);

  public ctaClick = output<void>();
  public dismiss = output<void>();
}

export type TellentSubscriptionBannerWebComponent = TellentWebComponent<
  TellentSubscriptionBannerWrapComponent,
  'message' | 'type' | 'iconName' | 'ctaLabel' | 'isDismissible' | 'ctaClick' | 'dismiss'
>;
